type GetTaxInfoSharingConsentLabelParams = {
  payerNames: string[];
  /**
   * True when the payee is not from the US, not from Canada and is not a US
   * person. Those contractors get expanded consent copy that clarifies why the
   * tax information is collected and that Wingspan does not file their personal
   * income tax return.
   */
  isInternationalNonCanadaPayee?: boolean;
};

export function getTaxInfoSharingConsentLabel({
  payerNames,
  isInternationalNonCanadaPayee = false
}: GetTaxInfoSharingConsentLabelParams): string {
  const authorization = `I authorize Wingspan to share the tax information I've provided with my payer(s) on the Wingspan platform (${payerNames.join(
    ", "
  )}).`;

  if (isInternationalNonCanadaPayee) {
    return `${authorization} I understand this information may be used to verify my identity, confirm my tax status, and satisfy applicable legal, tax, withholding, reporting, and compliance requirements. Wingspan does not prepare or file my personal income tax return.`;
  }

  return `${authorization} I understand this information will be used for tax reporting purposes in accordance with applicable laws and regulations.`;
}
